// src\constants\contact.constants.js

export const CONTACT_TITLE = 'Contact me';
export const CONTACT_HEADER = 'get in touch';

export const CONTACT_INFO = [
  { key: 'Name', value: 'Mihir Shah' },
  { key: 'Address', value: 'Ahmedabad, Gujarat, India' },
  { key: 'Email', value: 'mihirshah2752@gmail.com' },
  { key: 'Contact', value: '+91 7016661953' },
  {
    key: 'Blog',
    value: 'Visit my published blogs',
    url: 'https://medium.com/@mihirshahwrites',
  },
  {
    key: 'Linkedin',
    value: 'Visit my Linkedin Profile',
    url: 'https://www.linkedin.com/in/mihir-shah2752/',
  },
  {
    key: 'Stack Overflow',
    value: 'Visit my Stack Overflow Profile',
    url: 'https://stackoverflow.com/users/18541538/mihir-shah',
  },
  {
    key: 'GitHub',
    value: 'Visit my GitHub Profile',
    url: 'https://github.com/mihirshah2752',
  },
];
